var dataUrlPrefix = 'data:image/svg+xml';
var parseDataUrl = function (url) {
    if (!url.startsWith(dataUrlPrefix)) {
        return null;
    }
    var rest = url.slice(dataUrlPrefix.length);
    var svgString;
    if (rest.startsWith(';base64,')) {
        try {
            svgString = atob(rest.slice(';base64,'.length));
        }
        catch (_a) {
            return new Error('Invalid base64 in data URL');
        }
    }
    else if (rest.startsWith(',')) {
        try {
            svgString = decodeURIComponent(rest.slice(','.length));
        }
        catch (_b) {
            return new Error('Invalid encoding in data URL');
        }
    }
    else if (rest.startsWith(';charset=utf-8,')) {
        try {
            svgString = decodeURIComponent(rest.slice(';charset=utf-8,'.length));
        }
        catch (_c) {
            return new Error('Invalid encoding in data URL');
        }
    }
    else {
        return new Error('Unsupported data URL format');
    }
    var doc = new DOMParser().parseFromString(svgString, 'image/svg+xml');
    var parserError = doc.querySelector('parsererror');
    if (parserError) {
        return new Error('Data URL SVG parse error: ' + parserError.textContent.trim());
    }
    if (!(doc.documentElement instanceof SVGSVGElement)) {
        return new Error('Data URL did not contain a valid SVG element');
    }
    return doc.documentElement;
};
export default parseDataUrl;
//# sourceMappingURL=parse-data-url.js.map